/** Lead follow-up status (registrations.lead_status) — Lead Requests only. */

export const REGISTRATION_LEAD_STATUS_OPTIONS = [
  { value: 'converted', label: 'Converted' },
  { value: 'follow_up_done', label: 'Follow Up Done' },
  { value: 'second_follow_up_done', label: '2nd Follow Up Done' },
  { value: 'third_follow_up_done', label: '3rd Follow Up Done' },
  { value: 'not_interested', label: 'Not Interested' },
  { value: 'call_back_required', label: 'Call Back Required' },
  { value: 'no_response', label: 'No Response' }
];

export const REGISTRATION_LEAD_STATUS_LABELS = Object.fromEntries(
  REGISTRATION_LEAD_STATUS_OPTIONS.map((o) => [o.value, o.label])
);
